import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Scheduling|Accommodation|Details|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamAccommodations,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSchedulingAccommodationDetails';
export type SPCandidateSchedulingAccommodationDetailsLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}ButtonDownloadDoc`
	| `${LocNameStart}ButtonEdit`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonDeny`
	| `${LocNameStart}ButtonRevoke`
	| `${LocNameStart}ButtonUpdate`
	| `${LocNameStart}ButtonApprove`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelLastUpdate`
	| `${LocNameStart}LabelDescription`
	| `${LocNameStart}LabelDataProviders`
	| `${LocNameStart}LabelNotes`
	| `${LocNameStart}LabelReviewNotes`;

export const spCandidateSchedulingAccommodationDetailsLocs: LocDefs<SPCandidateSchedulingAccommodationDetailsLocNames> =
	{
		SPCandidateSchedulingAccommodationDetailsTitleTab: {
			defaultValue: 'Accommodation Details',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Title.Detailstab',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonDownloadDoc: {
			defaultValue: 'Download Documenation',
			description: 'Download Documenation button text',
			displayPath: `${pathStart}Download Documenation`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.DownloadDoc',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonEdit: {
			defaultValue: 'Edit',
			description: 'Edit accommodation button text',
			displayPath: `${pathStart}Edit`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.EditAccom',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel accommodation button text',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.CancelEdit',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonDeny: {
			defaultValue: 'Deny',
			description: 'Deny accommodation button text',
			displayPath: `${pathStart}Deny`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Deny',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonRevoke: {
			defaultValue: 'Revoke',
			description: 'Revoke accommodation button text',
			displayPath: `${pathStart}Revoke`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Revoke',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonApprove: {
			defaultValue: 'Approve',
			description: 'Approve accommodation button text',
			displayPath: `${pathStart}Approve`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Approve',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsButtonUpdate: {
			defaultValue: 'Update',
			description: 'Update accommodation button text',
			displayPath: `${pathStart}Update`,
			displayType: 'Button',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.Button.Update',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: 'Label for: Expire Date.',
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.ExpireDate',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelStatus: {
			defaultValue: 'Status',
			description: 'Label for: Status.',
			displayPath: `${pathStart}Status`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.Status',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelLastUpdate: {
			defaultValue: 'Last Update',
			description: 'Label for: Last Update.',
			displayPath: `${pathStart}Last Update`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.LastUpdated',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelDescription: {
			defaultValue: 'Description',
			description: 'Label for: Description.',
			displayPath: `${pathStart}Description`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.Description',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelDataProviders: {
			defaultValue: 'Data Providers',
			description: 'Label for: Data Providers.',
			displayPath: `${pathStart}Data Providers`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.DataProviders',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelNotes: {
			defaultValue: 'Notes',
			description: 'Label for: Notes.',
			displayPath: `${pathStart}Notes`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.Notes',
			...sharedProperties,
		},
		SPCandidateSchedulingAccommodationDetailsLabelReviewNotes: {
			defaultValue: 'Review Notes',
			description: 'Label for: Review Notes.',
			displayPath: `${pathStart}Review Notes`,
			displayType: 'Label',
			legacyName: 'Exam.Accommodations/Candidate.Accommodations.FieldLabel.ReviewNotes',
			...sharedProperties,
		},
	};

export type SPCandidateSchedulingAccommodationDetailsLocType =
	LocMap<SPCandidateSchedulingAccommodationDetailsLocNames>;
